var generateClientData = function generateClientData(label, value) {
  return {
    label: label,
    value: value
  };
};
export default generateClientData;
//# sourceMappingURL=generateClientData.js.map